import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CmsLoadingComponent} from '@ox/utils';
import {environment} from '../../environments/environment';
import {StylingService} from '../services/styling/styling.service';

import {RemoteEntryComponent} from './entry.component';

//[DeepLinkingEffects]
@NgModule({
  declarations: [RemoteEntryComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: RemoteEntryComponent,
        loadChildren: () => environment.featureImport().then((m) => m.PdpMainModule)
      }
    ]),
    CmsLoadingComponent
  ],
  providers: [StylingService]
})
export class RemoteEntryModule {
}
